import { useAnalyticsErrorPageTracker } from '@cp-shared-19/frontend-ui';
import { ErrorPage } from 'components/error-page';
import React from 'react';

export const ForbiddenPage: React.FC = () => {
    useAnalyticsErrorPageTracker('accessDeniedError');
    return <ErrorPage type="forbidden-error" />;
};
